<template>
  <div
    class="product-items-table"
    id="items-table"
  >
    <accordion
      ref="accordion"
      class="product-items-table__accordion"
      :is-content-html="true"
      id="items-and-infos"
      :name="$t('ads.main.seo.table.name')"
    >
      <div class="product-additional-information__content | html-teaser">
        <a v-for="(value, key) in itemInfoMap"
           :key="key"
           class="product-items-table__element product-items-table__item"
           :href="value.url"
        >
          <div class="product-items-table__item-name">
            {{ key }}
          </div>
          <div class="product-items-table__item-value">
            {{ value.info }}
          </div>
        </a>
      </div>
    </accordion>
  </div>
</template>
<script>
  import Accordion from '../accordion/accordion.vue'

  export default {
    components: {
      Accordion
    },
    props: {
      itemInfoMap: Object
    },
    methods: {
      openAccordion() {
      this.$refs.accordion.open()
      }
    }
  }

</script>
